import JoyCheckbox from '@mui/joy/Checkbox';
import FormControl from '@mui/joy/FormControl';
import { ChangeEvent } from 'react';
import { SimpleOption } from '../../types';
import { useTheme } from '@mui/joy';

//import CustomCheckmark from '../shared/icons/CustomCheckmark';

export interface CheckboxesProps {
	values?: string[];
	onChange?: (values: string[]) => void;
	options: SimpleOption[];
	print?: boolean;
}

export default function Checkbox({
	options = [],
	values = [],
	onChange = (values) => console.log(values),
	print
}: CheckboxesProps) {
	//const [localValues, setLocalValues] = useState<string[]>(values);
	const theme = useTheme();

	function handleOnChange(
		event: ChangeEvent<HTMLInputElement> | null,
		id: string
	) {
		if (event?.target) {
			const { checked } = event.target;
			// const nVals = checked
			// 	? [...localValues, id]
			// 	: localValues.filter(d => d !== id);
			const nVals = checked ? [id] : [];
			//setLocalValues(nVals);
			onChange(nVals);
		}
	}

	// useEffect(() => {
	// 	if (values.some((val, index) => val !== localValues[index])) {
	// 		setLocalValues(values);
	// 	}
	// 	// eslint-disable-next-line react-hooks/exhaustive-deps
	// }, [values]);
	return (
		<div>
			{options.map(({ label, id }) => {
				return (
					<FormControl key={id} sx={{ marginBottom: print ? '1rem' : 0 }}>
						<JoyCheckbox
							label={label}
							size='sm'
							onChange={(e) => handleOnChange(e, id)}
							checked={values.includes(id)}
							slotProps={{
								label: {
									sx: {
										lineHeight: print ? 0 : '1.3'
									}
								}
							}}
							sx={{
								fontFamily: 'Source Sans Pro, sans-serif',
								fontSize: '16px',
								[`& .MuiCheckbox-checkbox`]: {
									borderRadius: '0px',
									marginTop: '.1rem',
									[`&.Mui-checked`]: {
										backgroundColor:
											theme.colorSchemes.light.palette.controls.controlFill
									}
								}
							}}
						/>
					</FormControl>
				);
			})}
		</div>
	);
}
